<template>
  <HeaderApp /> <LoadingProgress v-if="suplier == null" />
  <div
    :class="
      ' mx-2 mt-14 mb-5 p-3 h-full bg-slate-100 dark:bg-bgFullDark rounded-2xl ' +
      ($store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
    v-if="suplier != null"
    id="printDev"
  >
    <InvoiceHeader
      invoice_type="suplier_account_detail"
      v-if="isHide == true"
    />
    <div class="flex justify-between items-center mb-4">
      <h1 class="text-2xl font-bold text-gray-800 dark:text-gray-100">
        {{ $t("suplier_account_detail") }}
      </h1>
    </div>
    <div
      class="flex flex-col xl:flex-row min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-100"
    >
      <!-- Right Sidebar (Customer Info) -->
      <aside
        class="w-full xl:w-96 bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm overflow-y-auto"
      >
        <div class="flex items-center space-x-4 mb-6">
          <img
            class="w-16 h-16 rounded-full"
            :src="
              file_url +
              (suplier && suplier.suplier ? suplier.suplier.su_image : '')
            "
            v-if="suplier && suplier.suplier && suplier.suplier.su_image"
            alt="Profile Picture"
          />

          <div
            class="w-16 h-16 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-300"
            v-else
          >
            <span class="text-2xl font-bold">
              {{
                suplier && suplier.suplier
                  ? suplier.suplier.su_name.slice(0, 2).toUpperCase()
                  : ""
              }}
            </span>
          </div>
          <div>
            <!-- Assuming a suplier object with a nested su_id -->
            <p class="text-lg font-bold text-gray-800 dark:text-gray-100">
              {{ suplier && suplier.suplier ? suplier.suplier.su_name : "" }}
            </p>
            <p class="text-sm text-gray-500 dark:text-gray-400">
              #
              {{ suplier && suplier.suplier ? suplier.suplier.su_id : "" }}
            </p>
          </div>
        </div>

        <!-- Contact Buttons -->
        <div class="grid grid-cols-4 gap-2 mb-6">
          <button @click="generateLink(suplier.suplier.su_id)">
            <div
              class="bg-gray-200 dark:bg-gray-700 p-2 rounded-lg flex justify-center items-center"
            >
              <i
                class="fa-solid fa-link text-lg text-gray-600 dark:text-gray-300"
              ></i>
            </div>
          </button>
          <a
            :href="
              'tel:' +
              (suplier && suplier.suplier ? suplier.suplier.su_phone : '')
            "
          >
            <div
              class="bg-gray-200 dark:bg-gray-700 p-2 rounded-lg flex justify-center items-center"
            >
              <i
                class="fa-solid fa-phone-alt text-lg text-gray-600 dark:text-gray-300"
              ></i>
            </div>
          </a>
          <button @click="showModalAdd">
            <div
              class="bg-gray-200 dark:bg-gray-700 p-2 rounded-lg flex justify-center items-center"
            >
              <i
                class="fa-solid fa-plus text-lg text-gray-600 dark:text-gray-300"
              ></i>
            </div>
          </button>
          <button
            class="bg-gray-200 dark:bg-gray-700 p-2 rounded-lg flex justify-center items-center"
            @click="modalPrintA4"
          >
            <i
              class="fa-solid fa-print text-lg text-gray-600 dark:text-gray-300"
              v-if="isPrintLoading == false"
            ></i>

            <div
              class="flex items-center hover:shadow-mdtext-white flex justify-center items-center hover:shadow-md"
              role="status"
              v-else
            >
              <svg
                width="20"
                height="20"
                fill="currentColor"
                class="mr-2 animate-spin"
                viewBox="0 0 1792 1792"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-
56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z"
                ></path>
              </svg>
            </div>
          </button>
        </div>
        <!-- Recent Activity Section -->
        <div>
          <div class="space-y-4">
            <div class="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg shadow">
              <div
                class="flex items-center justify-between text-gray-600 dark:text-gray-300"
              >
                <p class="font-medium">
                  {{ $t("phone number") }}
                </p>
                <p class="text-sm">
                  {{
                    suplier && suplier.suplier ? suplier.suplier.su_phone : ""
                  }}
                </p>
              </div>

              <div
                class="flex items-center justify-between text-gray-600 dark:text-gray-300 mt-2"
              >
                <p class="font-medium">
                  {{ $t("address") }}
                </p>
                <p class="text-sm">
                  {{
                    suplier && suplier.suplier ? suplier.suplier.su_address : ""
                  }}
                </p>
              </div>
              <div
                class="flex items-center justify-between text-gray-600 dark:text-gray-300 mt-2"
              >
                <p class="font-medium">
                  {{ $t("city") }}
                </p>
                <p class="text-sm">
                  {{
                    suplier && suplier.suplier
                      ? suplier.suplier.city.ci_name
                      : ""
                  }}
                </p>
              </div>
              <div
                class="flex items-center justify-between text-gray-600 dark:text-gray-300 mt-2"
              >
                <p class="font-medium">
                  {{ $t("last_transaction") }}
                </p>
                <p class="text-sm">
                  {{
                    suplier && suplier.suplier
                      ? formatDate(suplier.suplier.updated_at)
                      : ""
                  }}
                </p>
              </div>
              <div
                class="flex items-center justify-between text-gray-600 dark:text-gray-300 mt-2"
                v-if="suplier && suplier.suplier && suplier.suplier.su_email"
              >
                <p class="font-medium">
                  {{ $t("email") }}
                </p>
                <p class="text-sm">
                  {{
                    suplier && suplier.suplier ? suplier.suplier.su_email : ""
                  }}
                </p>
              </div>
              <div
                class="flex items-center justify-between text-gray-600 dark:text-gray-300 mt-2"
                v-if="suplier && suplier.suplier && suplier.suplier.su_note"
              >
                <p class="font-medium">
                  {{ $t("note") }}
                </p>
                <p class="text-sm">
                  {{
                    suplier && suplier.suplier ? suplier.suplier.su_note : ""
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <br />
        <!-- Financial Info Cards -->
        <div class="space-y-4 mb-6">
          <div
            class="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg shadow border-t-4 border-red-400"
          >
            <p class="text-sm text-gray-500 dark:text-gray-400">
              {{ $t("remain_debt") }}
            </p>
            <p class="text-xl font-bold text-gray-800 dark:text-gray-100">
              {{ formatNumber(suplier.result_debt.dinar) }} {{ $t("dinar") }}
            </p>
            <p class="text-xl font-bold text-gray-800 dark:text-gray-100">
              {{ formatNumber(suplier.result_debt.dollar) }} {{ $t("dollar") }}
            </p>
          </div>
        </div>

        <div class="space-y-4 mb-6">
          <div
            class="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg shadow border-t-4 border-blue-400"
          >
            <p class="text-sm text-gray-500 dark:text-gray-400">
              {{ $t("invoice_count") }}
            </p>
            <p class="text-xl font-bold text-gray-800 dark:text-gray-100">
              {{ suplier.purchase_count }}
            </p>
          </div>
        </div>

        <div class="space-y-4 mb-6">
          <div
            class="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg shadow border-t-4 border-yellow-400"
          >
            <p class="text-sm text-gray-500 dark:text-gray-400">
              {{ $t("returned_buy_invoice_count") }}
            </p>
            <p class="text-xl font-bold text-gray-800 dark:text-gray-100">
              {{ suplier.returned_purchase_count }}
            </p>
          </div>
        </div>
      </aside>
      <br />
      <!-- Main Content Area -->
      <div class="w-full xl:w-1/2 flex-1 flex flex-col px-6">
        <!-- Top Navigation Bar -->
        <header
          class="flex flex-wrap items-center justify-between bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm mb-6 gap-2"
        >
          <div class="flex flex-wrap items-center gap-2">
            <button
              class="px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200"
              :class="{
                'bg-blue-600 text-white shadow hover:bg-blue-700':
                  which_page === 'debts',
                'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600':
                  which_page !== 'debts',
              }"
              @click="updatePage('debts')"
            >
              {{ $t("debts_list") }}
            </button>
            <button
              class="px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200"
              :class="{
                'bg-blue-600 text-white shadow hover:bg-blue-700':
                  which_page === 'purchases',
                'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600':
                  which_page !== 'purchases',
              }"
              @click="updatePage('purchases')"
            >
              {{ $t("purchases") }}
            </button>
            <button
              class="px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200"
              :class="{
                'bg-blue-600 text-white shadow hover:bg-blue-700':
                  which_page === 'reports',
                'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600':
                  which_page !== 'reports',
              }"
              @click="updatePage('reports')"
            >
              {{ $t("reports") }}
            </button>
          </div>
          <div class="w-full basis-full shrink-0">
            <div
              class="border-t h-2 border-gray-300 dark:border-gray-600 w-full"
            ></div>
          </div>
          <!-- Filter Section -->
          <div class="flex flex-wrap items-center justify-between mb-4 gap-4">
            <!-- Filter Buttons -->
            <div class="flex flex-wrap items-center gap-2">
              <button
                class="px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 shadow"
                :class="{
                  'bg-blue-600 text-white hover:bg-blue-700': period === 'all',
                  'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600':
                    period !== 'all',
                }"
                @click="periodChanged('all')"
              >
                {{ $t("all_time") }}
              </button>
              <button
                class="px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 shadow"
                :class="{
                  'bg-blue-600 text-white hover:bg-blue-700':
                    period === 'today',
                  'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600':
                    period !== 'today',
                }"
                @click="periodChanged('today')"
              >
                {{ $t("today") }}
              </button>
              <button
                class="px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 shadow"
                :class="{
                  'bg-blue-600 text-white hover:bg-blue-700':
                    period === 'yesterday',
                  'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600':
                    period !== 'yesterday',
                }"
                @click="periodChanged('yesterday')"
              >
                {{ $t("yesterday") }}
              </button>
              <button
                class="px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 shadow"
                :class="{
                  'bg-blue-600 text-white hover:bg-blue-700':
                    period === 'last7days',
                  'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600':
                    period !== 'last7days',
                }"
                @click="periodChanged('last7days')"
              >
                {{ $t("last7days") }}
              </button>
              <button
                class="px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 shadow"
                :class="{
                  'bg-blue-600 text-white hover:bg-blue-700':
                    period === 'last30days',
                  'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600':
                    period !== 'last30days',
                }"
                @click="periodChanged('last30days')"
              >
                {{ $t("last30days") }}
              </button>
              <button
                class="px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 shadow"
                :class="{
                  'bg-blue-600 text-white hover:bg-blue-700':
                    period === 'thismonth',
                  'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600':
                    period !== 'thismonth',
                }"
                @click="periodChanged('thismonth')"
              >
                {{ $t("thismonth") }}
              </button>
              <button
                class="px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 shadow"
                :class="{
                  'bg-blue-600 text-white hover:bg-blue-700':
                    period === 'lastmonth',
                  'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600':
                    period !== 'lastmonth',
                }"
                @click="periodChanged('lastmonth')"
              >
                {{ $t("lastmonth") }}
              </button>
              <button
                class="px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 shadow"
                :class="{
                  'bg-blue-600 text-white hover:bg-blue-700':
                    period === 'lastyear',
                  'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600':
                    period !== 'lastyear',
                }"
                @click="periodChanged('lastyear')"
              >
                {{ $t("lastyear") }}
              </button>
              <button
                class="px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 shadow"
                :class="{
                  'bg-blue-600 text-white hover:bg-blue-700':
                    period === 'thisyear',
                  'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600':
                    period !== 'thisyear',
                }"
                @click="periodChanged('thisyear')"
              >
                {{ $t("thisyear") }}
              </button>
            </div>
            <div class="flex lg:flex-row flex-col no-print">
              <div class="md:mx-2 my-1 md:my-0">
                <label
                  for="debtDate"
                  class="block mb-2 text-sm font-medium text-textBlack1 dark:text-textWhite1"
                  >{{ $t("start_date") }}
                </label>
                <input
                  type="date"
                  id="debtDate"
                  class="bg-white border text-sm border-gray-300 text-textBlack1 placeholder-gray-400 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-4/6 xl:w-40 lg:w-36 p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 remove-arrow"
                  v-model="startDate"
                  @change="getData"
                />
              </div>

              <div class="md:mx-2 my-1 md:my-0">
                <label
                  for="debtDate"
                  class="block mb-2 text-sm font-medium text-textBlack1 dark:text-textWhite1"
                  >{{ $t("end_date") }}</label
                >
                <input
                  type="date"
                  id="debtDate"
                  class="bg-white border text-sm border-gray-300 text-textBlack1 placeholder-gray-400 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-4/6 xl:w-40 lg:w-36 p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 remove-arrow"
                  v-model="endDate"
                  @change="getData"
                />
              </div>
            </div>
          </div>
        </header>
        <!-- Data Cards & Filters Section -->
        <div
          class="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm flex-1"
          v-if="which_page === 'debts'"
        >
          <!-- Data Table Section -->
          <div class="my-2 py-3 bg-white dark:bg-bgMeduimDark rounded-2xl">
            <div class="relative overflow-x-auto mt-4 mb-6">
              <div class="flex items-center justify-between pb-4 no-print">
                <label for="table-search" class="sr-only">{{
                  $t("search")
                }}</label>
                <div class="relative">
                  <!--in ltr change (right-0 to left-0) (pr-3 to pl-3)-->
                  <div
                    class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"
                  >
                    <svg
                      class="w-5 h-5 text-gray-400 dark:text-gray-500"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <!--in ltr change (pr-10 to pl-10)-->
                  <input
                    type="text"
                    id="table-search"
                    class="block w-40 md:w-full p-2 pr-10 text-sm bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 rounded-lg focus:ring-blue-500 focus:border-blue-500 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    :placeholder="$t('search')"
                    @input="
                      $store.commit(
                        'suplier_account/SET_SEARCH',
                        $event.target.value
                      )
                    "
                  />
                </div>
                <div class="flex">
                  <button
                    class="my_font bg-primaryColor hover:bg-blue-700 text-white font-bold py-1 px-4 rounded no-print"
                    @click="showColumnSelector = true"
                    id="button_print"
                    v-if="$store.getters['checkPrintAccess']"
                  >
                    <i
                      class="fa-solid fa-print text-lg text-white dark:text-white"
                      v-if="isPrintLoading == false"
                    ></i>

                    <div
                      class="flex items-center hover:shadow-mdtext-white flex justify-center items-center hover:shadow-md"
                      role="status"
                      v-else
                    >
                      <svg
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="mr-2 animate-spin"
                        viewBox="0 0 1792 1792"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-
56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z"
                        ></path>
                      </svg>
                    </div>
                  </button>
                  <div class="w-2"></div>
                  <button
                    class="my_font bg-green-500 hover:bg-green-700 text-white font-bold py-1 px-4 rounded no-print"
                    @click="showModalAdd"
                  >
                    {{ $t("new_debt") }}
                  </button>
                </div>
              </div>
              <!--in ltr change (text-right to text-left)-->
              <EasyDataTable
                :headers="headers"
                :items="filterItems"
                :body-text-direction="
                  $store.getters['isRtl'] ? 'right' : 'left'
                "
                alternating
                :header-props="{
                  'sort-icon': 'fa-solid fa-arrow-up-wide-short',
                }"
                :loading="isLoadingData"
                :class="isDark ? 'customize-table ' : 'light-mode-table'"
                :hide-footer="isHide"
                :rows-items="[25, 50, 100, filterItems.length]"
                rows-per-page="10"
              >
                <template #default="{ column, sortDirection }">
                  <span class="custom-sort-icon" v-if="column.sortable">
                    <i
                      v-if="sortDirection === 'asc'"
                      class="fa-solid fa-arrow-up-wide-short"
                    ></i>
                    <i
                      v-else-if="sortDirection === 'desc'"
                      class="fa-solid fa-arrow-up-wide-short"
                    ></i>
                    <i v-else class="fa-solid fa-arrow-up-wide-short"></i>
                  </span>
                  {{ column.label }}
                </template>
                <template #item-deb_amount="item">
                  <span
                    :class="
                      item.deb_type == $t('sale_due')
                        ? 'text-yellow-500 font-bold'
                        : ''
                    "
                    v-show="item.deb_type == $t('sale_due')"
                  >
                    {{ formatNumber(item.deb_amount) }}
                  </span>
                  <span
                    :class="
                      item.deb_type == $t('purchase_due')
                        ? 'text-yellow-500 font-bold'
                        : ''
                    "
                    v-show="item.deb_type == $t('purchase_due')"
                  >
                    {{ formatNumber(item.deb_amount) }}
                  </span>
                  <span
                    :class="
                      item.deb_type == $t('borrow')
                        ? 'text-green-500 font-bold'
                        : ''
                    "
                    v-show="item.deb_type == $t('borrow')"
                  >
                    {{ formatNumber(item.deb_amount) }}
                  </span>
                  <span
                    :class="
                      item.deb_type == $t('lend')
                        ? 'text-red-500 font-bold'
                        : ''
                    "
                    v-show="item.deb_type == $t('lend')"
                  >
                    {{ formatNumber(item.deb_amount) }}
                  </span>
                  <span
                    :class="
                      item.deb_type == $t('returned_purchase')
                        ? 'text-red-500 font-bold'
                        : ''
                    "
                    v-show="item.deb_type == $t('returned_purchase')"
                  >
                    {{ formatNumber(item.deb_amount) }}
                  </span>
                </template>
                <template #item-actions="item">
                  <button
                    class="mx-1"
                    @click="showModal(item)"
                    v-if="
                      $store.getters['checkUserAccess']({
                        id: '21',
                        action: 'edit',
                      })
                    "
                  >
                    <i
                      class="fa-solid fa-pen text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
                    >
                      {{ item.text }}
                    </i>
                  </button>
                  <button
                    class="mx-1"
                    @click="deleteItem(item.deb_id)"
                    v-if="
                      $store.getters['checkUserAccess']({
                        id: '21',
                        action: 'delete',
                      })
                    "
                  >
                    <i
                      class="fa-solid fa-trash text-center p-1 w-7 h-7 text-sm bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto"
                    ></i>
                  </button>
                  <a
                    class="mx-1"
                    target="_blank"
                    :href="'../debt-detail/' + item.deb_id"
                    v-if="
                      $store.getters['checkUserAccess']({
                        id: '21',
                        action: 'detail',
                      })
                    "
                  >
                    <i
                      class="m-1 fa-solid fa-eye text-center p-1 w-7 h-7 text-sm bg-green-200 dark:bg-blue-300 rounded-md text-green-500 mx-auto"
                    >
                      {{ item.text }}
                    </i>
                  </a></template
                >

                <template #item-currency_cur_name="item">
                  {{ $t(item.cur_name) }} </template
                ><template #item-deb_image="item">
                  <img
                    :src="file_url + item.deb_image"
                    class="inline-flex items-center justify-center text-white transition-all duration-200 ease-in-out text-size-sm h-16 w-16 rounded-xl"
                    v-if="item.deb_image"
                    @click="openModal(file_url + item.deb_image)"
                  />
                  <span v-if="item.deb_image == '' || item.deb_image == null">
                    <i class="fa-solid fa-image text-primaryColor"></i>
                  </span>
                </template>
                <template #item-deb_type="item">
                  <span
                    :class="
                      item.deb_type == $t('sale_due')
                        ? 'text-yellow-500 font-bold'
                        : ''
                    "
                    v-show="item.deb_type == $t('sale_due')"
                  >
                    {{ $t("sale_due") }}
                  </span>
                  <span
                    :class="
                      item.deb_type == $t('purchase_due')
                        ? 'text-yellow-500 font-bold'
                        : ''
                    "
                    v-show="item.deb_type == $t('purchase_due')"
                  >
                    {{ $t("purchase_due") }}
                  </span>
                  <span
                    :class="
                      item.deb_type == $t('borrow')
                        ? 'text-green-500 font-bold'
                        : ''
                    "
                    v-show="item.deb_type == $t('borrow')"
                  >
                    {{ $t("borrow") }}
                  </span>
                  <span
                    :class="
                      item.deb_type == $t('lend')
                        ? 'text-red-500 font-bold'
                        : ''
                    "
                    v-show="item.deb_type == $t('lend')"
                  >
                    {{ $t("lend") }}
                  </span>
                  <span
                    :class="
                      item.deb_type == $t('returned_purchase')
                        ? 'text-red-500 font-bold'
                        : ''
                    "
                    v-show="item.deb_type == $t('returned_purchase')"
                  >
                    {{ $t("returned_purchase") }}
                  </span>
                </template>
                <template #item-total_usd="item">
                  <span
                    :class="
                      item.total_usd > 0
                        ? 'bg-red-500 font-bold text-white px-2 rounded-sm'
                        : 'bg-green-500 font-bold text-white px-2 rounded-sm'
                    "
                  >
                    {{ formatNumber(item.total_usd) }}
                  </span>
                </template>
                <template #item-total_iqd="item">
                  <span
                    :class="
                      item.total_iqd > 0
                        ? 'bg-red-500 font-bold text-white px-2 rounded-sm'
                        : 'bg-green-500 font-bold text-white px-2 rounded-sm'
                    "
                  >
                    {{ formatNumber(item.total_iqd) }}
                  </span>
                </template>
                <template #loading>
                  <img
                    src="../../assets/loading.webp"
                    style="width: 70px; height: 70px"
                  />
                </template>
                <template #item-created_at="item">
                  {{ formatDate(item.created_at) }} </template
                ><template #empty-message>
                  <span class="text-textBlack1 dark:text-white">
                    {{ $t("no_data_found") }}
                  </span>
                </template>
                <template
                  #pagination="{ prevPage, nextPage, isFirstPage, isLastPage }"
                >
                  <button :disabled="isFirstPage" @click="prevPage">
                    <i
                      :class="
                        'fa-sharp fa-solid ' +
                        ($store.getters['isRtl']
                          ? ' fa-chevron-right'
                          : ' fa-chevron-left')
                      "
                    ></i>
                  </button>
                  <div class="w-5"></div>
                  <button :disabled="isLastPage" @click="nextPage">
                    <i
                      :class="
                        'fa-sharp fa-solid ' +
                        ($store.getters['isRtl']
                          ? ' fa-chevron-left'
                          : ' fa-chevron-right')
                      "
                    ></i>
                  </button>
                </template>
              </EasyDataTable>
            </div>
          </div>
        </div>
        <div
          class="grid grid-cols-1 md:grid-cols-3 mt-4 mb-6 gap-x-4 gap-y-8"
          v-if="which_page === 'reports'"
        >
          <ReportComponentButton
            :labelDolar="formatNumber(suplier.result_debt.dollar)"
            :labelDinar="formatNumber(suplier.result_debt.dinar)"
            :labelTitle="$t('remain_debt')"
            startColor=" border-yellow-500 "
            classColor=" from-yellow-400 "
            buttonColor=" bg-yellow-950 "
            toColor=" to-yellow-400 "
          />
          <ReportComponentButton
            :labelDolar="formatNumber(suplier.debt_grouped.borrow.dollar)"
            :labelDinar="formatNumber(suplier.debt_grouped.borrow.dinar)"
            :labelTitle="$t('borrow')"
            startColor=" border-green-500 "
            classColor=" from-green-400 "
            buttonColor=" bg-green-950 "
            toColor=" to-green-400 "
          />
          <ReportComponentButton
            :labelDolar="formatNumber(suplier.debt_grouped.purchase.dollar)"
            :labelDinar="formatNumber(suplier.debt_grouped.purchase.dinar)"
            :labelTitle="$t('purchase_due')"
            startColor=" border-green-500 "
            classColor=" from-green-400 "
            buttonColor=" bg-green-950 "
            toColor=" to-green-400 "
          />
          <ReportComponentButton
            :labelDolar="formatNumber(suplier.debt_grouped.lend.dollar)"
            :labelDinar="formatNumber(suplier.debt_grouped.lend.dinar)"
            :labelTitle="$t('lend')"
            startColor=" border-red-500 "
            classColor=" from-red-400 "
            buttonColor=" bg-red-950 "
            toColor=" to-red-400 "
          />
          <ReportComponentButton
            :labelDolar="formatNumber(suplier.debt_grouped.invoice.dollar)"
            :labelDinar="formatNumber(suplier.debt_grouped.invoice.dinar)"
            :labelTitle="$t('sale_due')"
            startColor=" border-red-500 "
            classColor=" from-red-400 "
            buttonColor=" bg-red-950 "
            toColor=" to-red-400 "
          />
          <ReportComponentButton
            :labelDolar="
              formatNumber(suplier.debt_grouped.return_purchase.dollar)
            "
            :labelDinar="
              formatNumber(suplier.debt_grouped.return_purchase.dinar)
            "
            :labelTitle="$t('return_to_suplier_by_due')"
            startColor=" border-red-500 "
            classColor=" from-red-400 "
            buttonColor=" bg-red-950 "
            toColor=" to-red-400 "
          />

          <ReportComponentButton
            :labelDolar="formatNumber(suplier.purchase_grouped_price.dollar)"
            :labelDinar="formatNumber(suplier.purchase_grouped_price.dinar)"
            :labelTitle="$t('total_purchases_price')"
            startColor=" border-purple-500 "
            classColor=" from-purple-400 "
            buttonColor=" bg-purple-950 "
            toColor=" to-purple-400 "
          />

          <ReportComponentButton
            :labelDolar="
              formatNumber(suplier.returned_purchase_grouped_price.dollar)
            "
            :labelDinar="
              formatNumber(suplier.returned_purchase_grouped_price.dinar)
            "
            :labelTitle="$t('retuned_purchases_total_amount')"
            startColor=" border-purple-500 "
            classColor=" from-purple-400 "
            buttonColor=" bg-purple-950 "
            toColor=" to-purple-400 "
          />
        </div>
        <div
          v-if="which_page === 'purchases'"
          class="my-2 py-3 bg-white dark:bg-bgMeduimDark rounded-2xl bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm flex-1"
        >
          <div class="relative overflow-x-auto mt-4 mb-6">
            <div class="flex items-center justify-between pb-4 mx-5 no-print">
              <label for="table-search" class="sr-only">{{
                $t("search")
              }}</label>
              <div class="relative">
                <!--in ltr change (right-0 to left-0) (pr-3 to pl-3)-->
                <div
                  class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"
                >
                  <svg
                    class="w-5 h-5 text-gray-400 dark:text-gray-500"
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </div>
                <!--in ltr change (pr-10 to pl-10)-->
                <input
                  type="text"
                  id="table-search"
                  class="block w-40 md:w-full p-2 pr-10 text-sm bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 rounded-lg focus:ring-blue-500 focus:border-blue-500 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  :placeholder="$t('search')"
                  @input="
                    $store.commit(
                      'suplier_account/SET_SEARCH',
                      $event.target.value
                    )
                  "
                />
              </div>
              <div class="flex">
                  <button
                    class="my_font bg-primaryColor hover:bg-blue-700 text-white font-bold py-1 px-4 rounded no-print"
                    @click="showColumnSelector = true"
                    id="button_print"
                    v-if="$store.getters['checkPrintAccess']"
                  >
                  <i
                    class="fa-solid fa-print text-lg text-white dark:text-white"
                    v-if="isPrintLoading == false"
                  ></i>

                  <div
                    class="flex items-center hover:shadow-mdtext-white flex justify-center items-center hover:shadow-md"
                    role="status"
                    v-else
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                      ></circle>
                      <path
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                  </div>
                </button>
              </div>
            </div>
            <!--in ltr change (text-right to text-left)-->
            <EasyDataTable
              :headers="headersPurchases"
              :items="filterItemsPurchases"
              :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
              alternating
              :header-props="{ 'sort-icon': 'fa-solid fa-arrow-up-wide-short' }"
              :loading="isLoadingData"
              :class="isDark ? 'customize-table ' : 'light-mode-table'"
              :hide-footer="isHide"
              :rows-items="[25, 50, 100, filterItemsPurchases.length]"
              rows-per-page="10"
            >
              <template #default="{ column, sortDirection }">
                <span class="custom-sort-icon" v-if="column.sortable">
                  <i
                    v-if="sortDirection === 'asc'"
                    class="fa-solid fa-arrow-up-wide-short"
                  ></i>
                  <i
                    v-else-if="sortDirection === 'desc'"
                    class="fa-solid fa-arrow-up-wide-short"
                  ></i>
                  <i v-else class="fa-solid fa-arrow-up-wide-short"></i>
                </span>
                {{ column.label }}
              </template>
              <template #item-actions="item">
                <a
                  class="mx-1 my-1"
                  :href="'../edit-purchase/' + item.pu_id"
                  v-if="
                    $store.getters['checkUserAccess']({
                      id: '17',
                      action: 'detail',
                    })
                  "
                >
                  <i
                    class="fa-solid fa-eye text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
                  >
                    {{ item.text }}
                  </i>
                </a>
              </template>
              <template #item-pu_paid_amount="item">
                {{ formatNumber(item.pu_paid_amount) }}
              </template>
              <template #item-pu_total_amount="item">
                {{ formatNumber(item.pu_total_amount) }}
              </template>
              <template #item-pu_due_amount="item">
                {{ formatNumber(item.pu_due_amount) }} </template
              ><template #item-cur_id="item">
                {{ $t(item.cur_id == "1" ? "dinar" : "dollar") }}
              </template>

              <template #item-pu_main_currency_price="item">
                {{ formatNumber(item.pu_main_currency_price) }}
              </template>

              <template #loading>
                <img
                  src="../../assets/loading.webp"
                  style="width: 70px; height: 70px"
                />
              </template>
              <template #item-pu_note="item">
                <span
                  v-if="item.pu_note == null || item.pu_note == ''"
                  class="text-lg font-bold"
                >
                  __
                </span>
                <span v-else>
                  {{ item.pu_note }}
                </span>
              </template>

              <template #item-created_at="item">
                {{ formatDate(item.created_at) }} </template
              ><template #empty-message>
                <span class="text-textBlack1 dark:text-white">
                  {{ $t("no_data_found") }}
                </span>
              </template>
              <template
                #pagination="{ prevPage, nextPage, isFirstPage, isLastPage }"
              >
                <button :disabled="isFirstPage" @click="prevPage">
                  <i
                    :class="
                      'fa-sharp fa-solid ' +
                      ($store.getters['isRtl']
                        ? ' fa-chevron-right'
                        : ' fa-chevron-left')
                    "
                  ></i>
                </button>
                <div class="w-5"></div>
                <button :disabled="isLastPage" @click="nextPage">
                  <i
                    :class="
                      'fa-sharp fa-solid ' +
                      ($store.getters['isRtl']
                        ? ' fa-chevron-left'
                        : ' fa-chevron-right')
                    "
                  ></i>
                </button>
              </template>
            </EasyDataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <edit-modal ref="addModal">
    <div class="items-center">
      <form @submit="addItem">
        <BaseInput
          v-model="deb_amount"
          :label="$t('debt_amount')"
          :placeholder="$t('debt_amount')"
          :rules="rules"
          type="number"
          :isError="checkRulesIsError(deb_amount, 'add', this.rules).isError"
          :errorMsg="checkRulesIsError(deb_amount, 'add', this.rules).errorMsg"
        /><DropdownInput
          v-model="cur_id"
          :label="$t('currency_type')"
          :items="convertToListIdValue"
          :placeholder="$t('currency_type')"
          :rules="rules_dropdown"
          :isError="
            checkRulesIsError(cur_id, 'add', this.rules_dropdown).isError
          "
          :errorMsg="
            checkRulesIsError(cur_id, 'add', this.rules_dropdown).errorMsg
          "
        /><DropdownInput
          v-model="deb_type"
          :label="$t('debt_type')"
          :placeholder="$t('debt_type')"
          :rules="rules_dropdown"
          :items="debtTypes"
          :isError="
            checkRulesIsError(deb_type, 'add', this.rules_dropdown).isError
          "
          :errorMsg="
            checkRulesIsError(deb_type, 'add', this.rules_dropdown).errorMsg
          "
        /><DropdownInput
          v-model="bo_id"
          :label="$t('box_debt')"
          :placeholder="$t('choose_box_if_debt_is_in_or_out_from_box')"
          :rules="no_rule"
          :items="convertToListIdValueBoxes"
          :isError="checkRulesIsError(bo_id, 'add', this.no_rule).isError"
          :errorMsg="checkRulesIsError(bo_id, 'add', this.no_rule).errorMsg"
          linkDrop="/all-box"
        />

        <BaseInput
          v-model="deb_wasl"
          :label="$t('debt_invoice_number')"
          :placeholder="$t('debt_invoice_number')"
          :rules="no_rule"
          :isError="checkRulesIsError(deb_wasl, 'edit', this.no_rule).isError"
          :errorMsg="checkRulesIsError(deb_wasl, 'edit', this.no_rule).errorMsg"
        />
        <BaseInput
          v-model="created_at"
          type="date"
          :label="$t('debt_date')"
          :placeholder="$t('debt_date')"
          :rules="no_rule"
          :isError="checkRulesIsError(created_at, 'edit', this.no_rule).isError"
          :errorMsg="
            checkRulesIsError(created_at, 'edit', this.no_rule).errorMsg
          "
        />
        <BaseInput
          v-model="deb_return_date"
          type="date"
          :label="$t('debt_return_date')"
          :placeholder="$t('debt_return_date')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(deb_return_date, 'edit', this.no_rule).isError
          "
          :errorMsg="
            checkRulesIsError(deb_return_date, 'edit', this.no_rule).errorMsg
          "
        />
        <TextAreaInput
          v-model="deb_note"
          :label="$t('note')"
          :placeholder="$t('note')"
          :rules="no_rule"
          :isError="checkRulesIsError(deb_note, 'edit', this.no_rule).isError"
          :errorMsg="checkRulesIsError(deb_note, 'edit', this.no_rule).errorMsg"
        />
        <div>
          <label
            for="image"
            class="block mb-2 text-base font-medium text-textBlack1 dark:text-textWhite1"
          >
            {{ $t("debt_photo") }}</label
          >
          <label
            for="image"
            class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 remove-arrow"
          >
            <i class="fa fa-cloud-upload mx-1"></i>
            {{ deb_image == "" ? $t("choose_debt_photo") : deb_image.name }}
          </label>
          <input
            type="file"
            v-on:change="onChange"
            :placeholder="$t('choose_debt_photo')"
            id="image"
            class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 remove-arrow"
          />
        </div>
        <br />
        <center>
          <ButtonInput
            type="button"
            @click="addItem"
            :label="$t('add')"
            :isLoading="isBtnLoading"
          />
        </center>
      </form>
    </div>
  </edit-modal>
  <edit-modal ref="editModal">
    <div class="items-center">
      <form @submit="editItem">
        <BaseInput
          v-model="current.deb_amount"
          :label="$t('debt_amount')"
          :placeholder="$t('debt_amount')"
          :rules="rules"
          type="number"
          :isError="
            checkRulesIsError(current.deb_amount, 'edit', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.deb_amount, 'edit', this.rules).errorMsg
          "
        />

        <BaseInput
          v-model="current.deb_wasl"
          :label="$t('debt_invoice_number')"
          :placeholder="$t('debt_invoice_number')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.deb_wasl, 'edit', this.no_rule).isError
          "
          :errorMsg="
            checkRulesIsError(current.deb_wasl, 'edit', this.no_rule).errorMsg
          "
        />
        <BaseInput
          v-model="current.created_at"
          type="date"
          :label="$t('debt_date')"
          :placeholder="$t('debt_date')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.created_at, 'edit', this.no_rule).isError
          "
          :errorMsg="
            checkRulesIsError(current.created_at, 'edit', this.no_rule).errorMsg
          "
        />
        <BaseInput
          v-model="current.deb_return_date"
          type="date"
          :label="$t('debt_return_date')"
          :placeholder="$t('debt_return_date')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.deb_return_date, 'edit', this.no_rule)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.deb_return_date, 'edit', this.no_rule)
              .errorMsg
          "
        />
        <TextAreaInput
          v-model="current.deb_note"
          :label="$t('note')"
          :placeholder="$t('note')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.deb_note, 'edit', this.no_rule).isError
          "
          :errorMsg="
            checkRulesIsError(current.deb_note, 'edit', this.no_rule).errorMsg
          "
        />
        <div>
          <label
            for="image"
            class="block mb-2 text-base font-medium text-textBlack1 dark:text-textWhite1"
          >
            {{ $t("debt_photo") }}</label
          >
          <label
            for="image"
            class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 remove-arrow"
          >
            <i class="fa fa-cloud-upload mx-1"></i>
            {{ deb_image == "" ? $t("choose_debt_photo") : deb_image.name }}
          </label>
          <input
            type="file"
            v-on:change="onChange"
            :placeholder="$t('choose_debt_photo')"
            id="image"
            class="bg-slate-100 border border-gray-300 text-textBlack1 placeholder-gray-400 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-bgFullDark dark:border-gray-600 dark:placeholder-gray-200 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 remove-arrow"
          />
        </div>
        <br />
        <center>
          <ButtonInput
            type="button"
            @click="editItem"
            :label="$t('edit')"
            :isLoading="isBtnEditLoading"
          />
        </center>
      </form>
    </div>
  </edit-modal>
  <image-modal ref="imageModal" />
  
  <!-- Column Selector Modal -->
  <div v-if="showColumnSelector" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-2xl w-full mx-4 max-h-96 overflow-y-auto">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100">
          {{ $t("select_columns_to_print") }}
        </h3>
        <button @click="showColumnSelector = false" class="text-gray-500 hover:text-gray-700">
          <i class="fa-solid fa-times text-xl"></i>
        </button>
      </div>
      
      <div class="mb-4">
        <h4 class="text-md font-medium text-gray-700 dark:text-gray-300 mb-2">
          {{ which_page === 'debts' ? $t("debt_columns") : $t("purchase_columns") }}
        </h4>
        <div class="grid grid-cols-2 gap-2">
          <label 
            v-for="column in (which_page === 'debts' ? availableDebtColumns : availablePurchaseColumns)" 
            :key="column.key"
            class="flex items-center space-x-2 cursor-pointer"
          >
            <input 
              type="checkbox" 
              :value="column.key"
              :checked="(which_page === 'debts' ? selectedDebtColumns : selectedPurchaseColumns).includes(column.key)"
              @change="toggleColumn(column.key)"
              class="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            />
            <span class="text-sm text-gray-700 dark:text-gray-300">{{ column.label }}</span>
          </label>
        </div>
      </div>
      
      <div class="flex justify-end space-x-2">
        <button 
          @click="showColumnSelector = false" 
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-md"
        >
          {{ $t("cancel") }}
        </button>
        <button 
          @click="printWithSelectedColumns" 
          class="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md"
        >
          {{ $t("print") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import InvoiceHeader from "../../components/Navbar/InvoiceHeader.vue";
import LoadingProgress from "../../components/loading-progress.vue";
import { formatDate } from "../../utils/functions";
import { formatNumber } from "../../utils/functions";
import moment from "moment";
import { FILE_URL } from "../../constants/config";
import ReportComponentButton from "../../components/Report/ReportComponentButton.vue";
import ImageModal from "../../components/Modals/ImageModal2.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import EditModal from "../../components/Modals/EditModal.vue";
import { CURRENCYS } from "../../constants/config";
import { printInvoiceA4 } from "../../helpers/printStatment";
import { i18n } from "../../main"; // Adjust the import path accordingly

import DropdownInput from "../../components/Inputs/DropdownInput.vue";
export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    LoadingProgress,
    ReportComponentButton,
    InvoiceHeader,
    ImageModal,
    BaseInput,
    TextAreaInput,
    ButtonInput,
    ResultDialog,

    DropdownInput,
    ConfirmDialogue,
    EditModal,
  },
  data() {
    return {
      firstName: "",
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      no_rule: [],
      su_name: "",
      su_note: "",
      su_phone: "",
      su_address: "",
      su_email: "",
      inputType: "text",
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      ci_id: "",
      isPrintLoading: false,
      which_page: "debts",
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      file_url: FILE_URL,
      su_image: "",
      startDate: "",
      endDate: "",
      period: "all",
      suplier: null,
      isHide: false,
      cur_id: "",
      su_id: "",
      bo_id: "",
      cu_id: "",
      deb_note: "",
      deb_wasl: "",
      deb_amount: "",
      created_at: "",
      deb_return_date: "",
      deb_type: "",
      deb_image: "",
      settings: {},
      
      // Column selection for printing
      selectedDebtColumns: [
        "debt_id", "created_at", "debt_amount", "debt_type", 
        "debt_result_dollar", "debt_result_dinar", "note", 
        "debt_invoice_number", "invoice_id"
      ],
      selectedPurchaseColumns: [
        "purchase_id", "created_at", "total_price", "paid_amount", 
        "due_amount", "currency_type", "note"
      ],
      showColumnSelector: false,

      debtTypes: [
        {
          id: "1",
          value: this.$t("lend"),
        },
        {
          id: "0",
          value: this.$t("borrow"),
        },
      ],
      currencys: CURRENCYS,
    };
  },
  created() {
    this.settings = JSON.parse(
      localStorage.getItem("currentSettingWiseManager")
    );
    this.$store.dispatch("all_box/getBoxes");

    this.$store.dispatch("debt_category/getExpenseCategory");
    this.$store.dispatch("customer/getCustomers");
    this.$store.dispatch("suplier/getSupliers");
    this.$store.dispatch("navbar/getItems");
    this.periodChanged("all");
    this.getData();
    this.$store.dispatch("sale_city/getCitys");
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.suplier_account.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.suplier_account.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("suplier_account/SET_DELETE_SUCCESS", false);
      }
    },
  },

  computed: {
    getResultDialog() {
      return this.$store.state.suplier_account.isShowResultDialog;
    },
    items() {
      return this.$store.state.suplier_account.items;
    },
    filterItems() {
      return this.$store.getters["suplier_account/filterItems"];
    },
    filterItemsPurchases() {
      return this.$store.getters["suplier_account/filterItemsPurchases"];
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.suplier_account.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.suplier_account.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.suplier_account.isBtnEditLoading;
    },
    headers() {
      var headerList = [
        { text: "#", value: "deb_id", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },

        { text: this.$t("photo"), value: "deb_image", sortable: false },

        { text: this.$t("debt_amount"), value: "deb_amount", sortable: true },
        {
          text: this.$t("currency_type"),
          value: "currency_cur_name",
          sortable: true,
        },
        {
          text: this.$t("dolar_price"),
          value: "deb_main_currency_price",
          sortable: true,
        },
        {
          text: this.$t("debt_type"),
          value: "deb_type",
          sortable: true,
        },
        { text: this.$t("debt_box"), value: "bo_name", sortable: true },
        {
          text: this.$t("debt_result_dollar"),
          value: "total_usd",
          sortable: true,
        },
        {
          text: this.$t("debt_result_dinar"),
          value: "total_iqd",
          sortable: true,
        },
        {
          text: this.$t("debt_invoice_number"),
          value: "deb_wasl",
          sortable: true,
        },
        { text: this.$t("purchase_id"), value: "pu_id", sortable: true },
        { text: this.$t("note"), value: "deb_note", sortable: true },
        {
          text: this.$t("debt_return_date"),
          value: "deb_return_date",
          sortable: true,
        },

        { text: this.$t("admin"), value: "name", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
      //remove actions,deb_image if not isHide=true
      if (this.isHide) {
        headerList.pop();
        headerList.splice(2, 1);
      }

      return headerList;
    },
    headersPurchases() {
      return [
        //pu_id,st_id,pu_total_amount,pu_paid_amount,pu_total_amount,pu_due_amount,in_status,in_main_currency_price,admin

        { text: this.$t("purchase_id"), value: "pu_id", sortable: true },
        {
          text: this.$t("total_price"),
          value: "pu_total_amount",
          sortable: true,
        },
        {
          text: this.$t("paid_amount"),
          value: "pu_paid_amount",
          sortable: true,
        },
        { text: this.$t("due_amount"), value: "pu_due_amount", sortable: true },
        { text: this.$t("currency_type"), value: "cur_id", sortable: true },
        {
          text: this.$t("dolar_price"),
          value: "pu_main_currency_price",
          sortable: true,
        },

        { text: this.$t("note"), value: "pu_note", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
    },
    convertToListIdValue() {
      var list = [];
      for (const item of this.currencys) {
        list.push({
          id: item.cur_id,
          value: this.$t(item.cur_name),
        });
      }

      return list;
    },
    convertToListIdValueBoxes() {
      var boxes = this.$store.state.all_box.boxes;
      var list = [];
      for (const item of boxes) {
        list.push({
          id: item.bo_id,
          value: item.bo_name,
        });
      }

      return list;
    },
    convertToListIdValueCustomers() {
      var customers = this.$store.state.customer.customers;
      var list = [];
      for (const item of customers) {
        list.push({
          id: item.cu_id,
          value: item.cu_name,
        });
      }

      return list;
    },
    convertToListIdValueSupliers() {
      var supliers = this.$store.state.suplier.supliers;
      var list = [];
      for (const item of supliers) {
        list.push({
          id: item.su_id,
          value: item.su_name,
        });
      }

      return list;
    },
    availableDebtColumns() {
      return [
        { key: "debt_id", label: this.$t("debt_id") },
        { key: "created_at", label: this.$t("created_at") },
        { key: "debt_amount", label: this.$t("debt_amount") },
        { key: "debt_type", label: this.$t("debt_type") },
        { key: "debt_result_dollar", label: this.$t("debt_result_dollar") },
        { key: "debt_result_dinar", label: this.$t("debt_result_dinar") },
        { key: "note", label: this.$t("note") },
        { key: "debt_invoice_number", label: this.$t("debt_invoice_number") },
        { key: "invoice_id", label: this.$t("invoice_id") },
        { key: "currency_type", label: this.$t("currency_type") },
        { key: "dolar_price", label: this.$t("dolar_price") },
        { key: "box", label: this.$t("box") },
        { key: "admin", label: this.$t("admin") },
        { key: "debt_return_date", label: this.$t("debt_return_date") }
      ];
    },
    availablePurchaseColumns() {
      return [
        { key: "purchase_id", label: this.$t("purchase_id") },
        { key: "created_at", label: this.$t("created_at") },
        { key: "total_price", label: this.$t("total_price") },
        { key: "paid_amount", label: this.$t("paid_amount") },
        { key: "due_amount", label: this.$t("due_amount") },
        { key: "currency_type", label: this.$t("currency_type") },
        { key: "dolar_price", label: this.$t("dolar_price") },
        { key: "note", label: this.$t("note") }
      ];
    },
  },

  methods: {
    async modalPrintA4() {
      this.isPrintLoading = true;
      //proccess purchase_items to send to printInvoiceA4 get name by id and others put to new array
      var itemsToprint = this.filterItems.map((item) => {
        return {
          //show debts
          debt_id: item.deb_id,
          created_at: this.formatDate(item.created_at),
          debt_amount:
            this.formatNumber(item.deb_amount) + this.$t(item.cur_name),

          debt_type: item.deb_type,
          debt_result_dollar: this.formatNumber(item.total_usd),
          debt_result_dinar: this.formatNumber(item.total_iqd),
          note: item.deb_note != null ? item.deb_note : "-",
          debt_invoice_number: item.deb_wasl != null ? item.deb_wasl : "-",
          invoice_id: item.in_id != null ? item.in_id : "-",
        };
      });

      const sampleData = {
        invoiceTitle: this.$t("suplier_account_detail"),

        name:
          this.suplier.suplier.su_name + " - " + this.suplier.suplier.su_phone,
        name_var: "suplier_name",
        id: this.suplier.suplier.su_id,
        invoiceDate: this.formatDate(moment().format("YYYY-MM-DD")),
        headerMessage: this.$t("suplier_account_detail"),
        startDate: this.formatDate(this.startDate).toString().substring(0, 10),
        endDate: this.formatDate(this.endDate).toString().substring(0, 10),
        companyInfo: {
          appName: this.settings.app_name,
          phoneNumber: this.settings.set_phone_number,
          phoneNumber2: this.settings.set_phone_number2,
          logoUrl: this.file_url + this.settings.set_logo,
          address: this.settings.set_address,
        },
        tableColumns: this.selectedDebtColumns,
        items: itemsToprint,

        summary: {
          // itemsPrice: 55.5,
          debtDinar: this.suplier.result_debt.dinar,
          debtDollar: this.suplier.result_debt.dollar,
        },
      };
      const t = i18n.global.t;

      printInvoiceA4(sampleData, this.formatNumber, t);
      this.isPrintLoading = false;
    },
    async modalPrintPurchasesA4() {
      this.isPrintLoading = true;
      //process purchases to send to printInvoiceA4
      var itemsToprint = this.filterItemsPurchases.map((item) => {
        return {
          //show purchases
          purchase_id: item.pu_id,
          created_at: this.formatDate(item.created_at),
          total_price: this.formatNumber(item.pu_total_amount) + " " + this.$t(item.cur_id == "1" ? "dinar" : "dollar"),
          paid_amount: this.formatNumber(item.pu_paid_amount) + " " + this.$t(item.cur_id == "1" ? "dinar" : "dollar"),
          due_amount: this.formatNumber(item.pu_due_amount) + " " + this.$t(item.cur_id == "1" ? "dinar" : "dollar"),
          currency_type: this.$t(item.cur_id == "1" ? "dinar" : "dollar"),
          dolar_price: this.formatNumber(item.pu_main_currency_price),
          note: item.pu_note != null ? item.pu_note : "-",
        };
      });

      const sampleData = {
        invoiceTitle: this.$t("suplier_purchases_report"),

        name:
          this.suplier.suplier.su_name + " - " + this.suplier.suplier.su_phone,
        name_var: "suplier_name",
        id: this.suplier.suplier.su_id,
        invoiceDate: this.formatDate(moment().format("YYYY-MM-DD")),
        headerMessage: this.$t("suplier_purchases_report"),
        startDate: this.formatDate(this.startDate).toString().substring(0, 10),
        endDate: this.formatDate(this.endDate).toString().substring(0, 10),
        companyInfo: {
          appName: this.settings.app_name,
          phoneNumber: this.settings.set_phone_number,
          phoneNumber2: this.settings.set_phone_number2,
          logoUrl: this.file_url + this.settings.set_logo,
          address: this.settings.set_address,
        },
        tableColumns: this.selectedPurchaseColumns,
        items: itemsToprint,

        summary: {
          // itemsPrice: 55.5,
          totalPurchases: this.suplier.result_purchase ? this.suplier.result_purchase.total : 0,
          totalPaid: this.suplier.result_purchase ? this.suplier.result_purchase.paid : 0,
          totalDue: this.suplier.result_purchase ? this.suplier.result_purchase.due : 0,
          debtDinar: this.suplier.result_debt.dinar,
          debtDollar: this.suplier.result_debt.dollar,
        },
      };
      const t = i18n.global.t;

      printInvoiceA4(sampleData, this.formatNumber, t);
      this.isPrintLoading = false;
    },
    toggleColumn(columnKey) {
      if (this.which_page === 'debts') {
        const index = this.selectedDebtColumns.indexOf(columnKey);
        if (index > -1) {
          this.selectedDebtColumns.splice(index, 1);
        } else {
          this.selectedDebtColumns.push(columnKey);
        }
      } else {
        const index = this.selectedPurchaseColumns.indexOf(columnKey);
        if (index > -1) {
          this.selectedPurchaseColumns.splice(index, 1);
        } else {
          this.selectedPurchaseColumns.push(columnKey);
        }
      }
    },
    printWithSelectedColumns() {
      this.showColumnSelector = false;
      if (this.which_page === 'debts') {
        this.modalPrintA4();
      } else {
        this.modalPrintPurchasesA4();
      }
    },
    async showModal(item) {
      this.current = item;
      //if not null
      this.current.created_at = this.current.created_at
        .toString()
        .split("T")[0];
      if (this.current.su_id != null) {
        //check if su_id number
        if (typeof this.current.su_id == "number") {
          this.current.su_id = {
            id: item.su_id,
            value: item.suplier != null ? item.suplier.su_name : "",
          };
        } else {
          this.current.su_id = {
            id: item.su_id.id,
            value: item.suplier != null ? item.suplier.su_name : "",
          };
        }
      } else {
        this.current.su_id = {
          id: "",
          value: "",
        };
      }
      if (this.current.cu_id != null) {
        //check if cu_id number
        if (typeof this.current.cu_id == "number") {
          this.current.cu_id = {
            id: item.cu_id,
            value: item.customer != null ? item.customer.cu_name : "",
          };
        } else {
          this.current.cu_id = {
            id: item.cu_id.id,
            value: item.customer != null ? item.customer.cu_name : "",
          };
        }
      } else {
        this.current.cu_id = {
          id: "",
          value: "",
        };
      }
      await this.$refs.editModal.show();
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        this.$store.commit("debt_list/REMOVE_ITEM", id);
        await this.$store.dispatch("debt_list/deleteItem", id);
        this.getData();
      }
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;

      if (
        this.checkRulesIsError(this.current.deb_amount, "edit", this.rules)
          .isError
      ) {
        return;
      }

      this.$store.state.suplier_account.isBtnEditLoading = true;
      var res = await this.$store.dispatch("debt_list/editItem", {
        deb_id: this.current.deb_id,
        su_id: this.current.su_id.id,
        deb_note: this.current.deb_note,
        deb_wasl: this.current.deb_wasl,
        deb_amount: this.current.deb_amount,
        created_at: this.current.created_at,
        deb_return_date: this.current.deb_return_date,

        deb_image: this.deb_image,
      });

      this.isSubmitedEdit = false;
      this.$store.state.suplier_account.isBtnEditLoading = false;
      this.deb_image = "";
      if (res.status == 200) {
        this.$refs.editModal.hide();
        this.getData();
      }
    },
    checkIsEmpty(value) {
      if (value == "" || value == null) return true;
      return false;
    },
    updatePage(page) {
      this.which_page = page;
    },
    printReportFunc() {
      this.isHide = true;
      //wait 1 second
      setTimeout(() => {
        var printContents = document.getElementById("printDev").innerHTML;

        // Replace the body's innerHTML with the print contents
        document.body.innerHTML = printContents;
        var isRtl = this.$store.getters["isRtl"];
        // Set direction based on the parameter
        if (isRtl) {
          document.body.style.direction = "rtl";
        } else {
          document.body.style.direction = "ltr";
        }

        // Print the content
        window.print();
        //reload page
      }, 100);
      //print element id invoice_print
    },
    onChange(e) {
      this.deb_image = e.target.files[0];
      e.target.value = "";
    },
    formatNumber(number) {
      return formatNumber(number);
    },
    formatDate(date) {
      return formatDate(date);
    },
    openModal(image) {
      this.$refs.imageModal.show(image);
    },
    async showModalAdd(item) {
      this.current = item;

      await this.$refs.addModal.show();
    },
    async addItem() {
      //check form validation
      if (this.$store.state.suplier_account.isBtnLoading) return;

      this.isSubmited = true;
      if (
        this.checkRulesIsError(this.cur_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.deb_type, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.deb_amount, "add", this.rules).isError
      ) {
        return;
      }
      this.su_id = {
        id: this.$route.params.id,
      };

      this.$store.state.suplier_account.isBtnLoading = true;
      var res = await this.$store.dispatch("add_debt/addNewItem", {
        cur_id: this.cur_id,
        deb_type: this.deb_type,
        bo_id: this.bo_id,
        su_id: this.su_id.id,
        deb_note: this.deb_note,
        deb_wasl: this.deb_wasl,
        deb_amount: this.deb_amount,
        deb_main_currency_price: this.$store.state.navbar.dp_price,
        created_at: this.created_at,
        deb_return_date: this.deb_return_date,
        cu_id: "",
        deb_image: this.deb_image,
      });
      if (res.status == 200) {
        this.deb_amount = "";
        this.deb_note = "";
        this.deb_wasl = "";
        this.cur_id = "";
        this.deb_type = "";
        this.bo_id = "";
        this.cu_id = "";
        this.su_id = "";
        this.created_at = "";
        this.deb_return_date = "";
        this.$store.state.suplier_account.isBtnLoading = false;
        this.isSubmited = false;
        //close modal

        this.getData();
        this.$refs.addModal.hide();
      }
    },
    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },    async generateLink(id) {
      var payload = {
        id: id,
        path: "/debt",
        type: "supplier",
      };
      await this.$store.dispatch("suplier/generateLink", payload);
    },
    periodChanged(action) {
      this.period = action;

      if (action == "today") {
        this.startDate = moment().format("YYYY-MM-DD");
        this.endDate = moment().format("YYYY-MM-DD");
      } else if (action == "yesterday") {
        this.startDate = moment().subtract(1, "days").format("YYYY-MM-DD");
        this.endDate = moment().subtract(1, "days").format("YYYY-MM-DD");
      } else if (action == "last7days") {
        this.startDate = moment().subtract(7, "days").format("YYYY-MM-DD");
        this.endDate = moment().format("YYYY-MM-DD");
      } else if (action == "last30days") {
        this.startDate = moment().subtract(30, "days").format("YYYY-MM-DD");
        this.endDate = moment().format("YYYY-MM-DD");
      } else if (action == "thismonth") {
        this.startDate = moment().startOf("month").format("YYYY-MM-DD");
        this.endDate = moment().endOf("month").format("YYYY-MM-DD");
      } else if (action == "lastmonth") {
        this.startDate = moment()
          .subtract(1, "months")
          .startOf("month")
          .format("YYYY-MM-DD");
        this.endDate = moment()
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD");
      } else if (action == "lastyear") {
        this.startDate = moment()
          .subtract(1, "years")
          .startOf("year")
          .format("YYYY-MM-DD");
        this.endDate = moment()
          .subtract(1, "years")
          .endOf("year")
          .format("YYYY-MM-DD");
      } else if (action == "thisyear") {
        this.startDate = moment().startOf("year").format("YYYY-MM-DD");
        this.endDate = moment().endOf("year").format("YYYY-MM-DD");
      }
      //all
      else if (action == "all") {
        // this.startDate = moment().startOf("year").format("YYYY-MM-DD");
        //start date = 1/1/2000
        this.startDate = "2000-01-01";
        this.endDate = moment().endOf("year").format("YYYY-MM-DD");
      }

      this.getData();
    },
    async getData() {
      var res = await this.$store.dispatch("suplier_account/getItems", {
        su_id: this.$route.params.id,
        startDate: this.startDate,
        endDate: this.endDate,
      });
      //check res status

      if (res.status == 200) {
        this.suplier = res.data;
      } else if (res.response.status == 404) {
        //back to suplier page
        //new window
        window.open("/suplier", "_self");
      }
    },
  },
};
</script>
